/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash'
import {
  useBrands,
  useCategories,
  useDepartments,
  useSystemSettings,
} from 'react-omnitech-api'
import {
  trackEventHook,
  trackEventGa,
  trackEventTenmax,
  trackEventFbp,
} from '../../helpers'

export default function useAnalytics() {
  const { getSystemSetting } = useSystemSettings()
  const { departments } = useDepartments()
  const { categories } = useCategories()
  const { brands } = useBrands()

  function trackEvent(eventName, options = {}, meta) {
    if (_.isEmpty(eventName)) {
      console.warn('trackEvent error: ', 'event name empty.')
      return
    }

    trackEventHook(eventName, options, meta)

    if (getSystemSetting('analytics.google.enable') === true) {
      trackEventGa(eventName, options, meta)
    }
    if (getSystemSetting('analytics.tenmax.enable')) {
      trackEventTenmax(eventName, options, meta)
    }
    if (getSystemSetting('analytics.facebook.enable')) {
      trackEventFbp(eventName, options, meta)
    }
  }

  function getProductParams(sku) {
    const categoryIds = _.get(sku, 'product.categoryIds', [])
    const brandIds = _.get(sku, 'product.brandIds', [])
    const category = _.join(
      _.compact(
        _.flatMap(categoryIds, (id) => (
          _.compact([
            _.get(
              _.find(
                departments,
                { id: _.get(_.find(categories, { id }), 'departmentId') },
              ),
              'name',
            ),
            _.get(_.find(categories, { id }), 'name'),
          ])
        )),
      ),
      ', ',
    )
    const brand = _.join(
      _.compact(
        _.map(brandIds, (id) => (
          _.get(_.find(brands, { id }), 'name')
        )),
      ),
      ', ',
    )
    return {
      code: _.get(sku, 'product.code'),
      name: _.get(sku, 'product.title'),
      category,
      brand,
      variant: _.get(sku, 'colorOption.name'),
    }
  }

  return {
    trackEvent,
    getProductParams,
  }
}
